import React from 'react'
import './page404.css'
export default function Page404() {
    window.onload = function(){
        document.querySelector('.cont_principal').className= "cont_principal cont_error_active";  
          
        }
  return (
    <div>
      <div class="cont_principal">
<div class="cont_error">
  
<h1>Oops...404</h1>  
  <p>The Page you're looking for isn't here.</p>
  </div>
<div class="cont_aura_1"></div>
<div class="cont_aura_2"></div>
</div>
    </div>
  )
}
